export const PAGE_LOCATORS = {
  EXPLORE_PAGE: 'ExplorePage',
  SAVED_PAGE: 'SavedPage'
} as const
